import SentimentTrackerPaymentContainer from 'containers/SentimentTracker/SentimentTrackerPayment';
import React from 'react';
// import SentimentTrackerPaymentContainer from 'containers/JarvisSentimentTracker/SentimentTrackerPayment';

function SentimentTrackerPayment() {
    return ( 
    <>
    <SentimentTrackerPaymentContainer />
    </> 
    );
}

export default SentimentTrackerPayment;